import { Plus, Sparkles } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { ANAMNESE_SNIPPETS } from "@/data/medicoData";

export const AnamneseTab = ({ value, onChange }) => {
  const insertSnippet = (text) => {
    onChange((prev) => (prev ? `${prev.trimEnd()}\n${text}` : text));
  };

  return (
    <div className="space-y-4">
      <div>
        <div className="mb-2.5 flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-blue-600" />
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">
            Modelos Rápidos — insira com 1 clique
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {ANAMNESE_SNIPPETS.map((s, i) => (
            <button
              key={i}
              data-testid={`snippet-${i}`}
              onClick={() => insertSnippet(s)}
              className="group inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-600 transition-colors duration-200 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
            >
              <Plus className="h-3 w-3 text-slate-400 group-hover:text-blue-600" />
              {s.length > 44 ? `${s.slice(0, 44)}…` : s}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
          Evolução Clínica
        </p>
        <Textarea
          data-testid="anamnese-textarea"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Descreva a evolução clínica do paciente, exame físico, hipóteses diagnósticas e conduta..."
          className="min-h-[280px] resize-y rounded-xl border-slate-200 bg-white text-sm leading-relaxed text-slate-800 focus-visible:ring-blue-600"
        />
        <p className="mt-2 text-right text-xs text-slate-400">
          {value.length} caracteres
        </p>
      </div>
    </div>
  );
};
